import Options from 'Constants/Options';
import BankCode from 'Constants/BankCode';
import { saveAs } from 'file-saver';

export function removeEmpty(data) {
  Object.keys(data).map(x => {
    if (data[x] === false || data[x] === 0) {
      return;
    }
    if (!data[x]) {
      delete data[x];
    }
  });
  return data;
}

export function deleteItems(data, target) {
  target.map(x => {
    delete data[x];
  });
  return data;
}

export function isEmptyObject(obj) {
  if (!obj) {
    return true;
  }
  return Object.keys(obj).length === 0;
}

export function returnAddress(addressList, id) {
  let addressName = '';
  if (!addressList) {
    return;
  }
  Object.values(addressList).map(x => {
    if (addressName) {
      return;
    }
    if (x._id === id) {
      addressName = x.name;
      return;
    }
  });
  return addressName;
}

export function returnDetailAddressList(addressList, addressId) {
  let detailAddressList = null;
  if (!addressList || !addressId) {
    return null;
  }
  Object.values(addressList).map(x => {
    if (detailAddressList) {
      return;
    }
    if (x._id === addressId) {
      detailAddressList = x.address2;
    }
  });
  if (!addressList) {
    detailAddressList = [];
  }
  return Object.values(detailAddressList);
}

export function returnDetailAddress(addressList, addressId, detailId) {
  let addressName = '';
  if (!addressList || !addressId || !detailId) {
    return null;
  }
  Object.values(addressList).map(x => {
    if (addressName) {
      return;
    }
    if (x._id === addressId) {
      x.address2.map(item => {
        if (item._id === detailId) {
          addressName = item.name;
        }
      });
      return;
    }
  });
  return addressName;
}

export function returnDetailAddressWithoutAddress(list) {
  let addressList = JSON.parse(localStorage.getItem('addressList'));
  if (!addressList) {
    return null;
  }
  let detailList = [];
  Object.values(addressList).forEach(x => {
    if (list.length === detailList.length) {
      return;
    }
    x.address2.forEach(item => {
      if (list.includes(item._id)) {
        detailList.push(item.name);
      }
    });
  });
  return detailList;
}

export function returnLabelByCode(key, value) {
  let data = Options[key];
  let label = '';
  if (!data) {
    return '';
  }
  data.forEach((item, index) => {
    if (label) {
      return;
    }
    if (item.value === value) {
      label = item.label;
    }
  });
  return label;
}

export function isOptionInclude(key, value) {
  let data = Options[key];
  let label = '';
  if (!data) {
    return false;
  }
  data.forEach(item => {
    if (label) {
      return;
    }
    if (item.value === value) {
      label = item.label;
    }
  });
  return label !== '';
}

export function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

export function removeEmptySEOData(data) {
  let { seo } = data;
  if (seo._id) {
    delete seo._id;
  }
  if (seo.keywords) {
    seo.keywords = seo.keywords.filter(x => x !== '');
  }
  seo = removeEmpty(seo);
  if (seo.keywords.length === 0) {
    delete seo.keywords;
  }
  if (isEmptyObject(seo)) {
    delete data.seo;
  }
  return data;
}

export function sortMaterials(data, status = 'REFUND', sort = 'DESC') {
  let orders = Object.assign([], data);
  orders.sort((a, b) => {
    let value = -1;
    if (b.status === status) value = 1;
    if (sort !== 'DESC') value = value * -1;
    return value;
  });
  return orders;
}

export function isBlank(data) {
  let isTrue = false;
  Object.keys(data).map(x => {
    if (data[x] === '' || data[x] === undefined || data[x] === null) {
      isTrue = true;
    }
  });
  return isTrue;
}

export function materialLogCategoryString(materialLog) {
  if (!materialLog || !materialLog.ancestors) return '';
  const result = [...materialLog.ancestors];
  if (materialLog.displayName) result.push(materialLog.displayName);
  return result.join(' > ');
}

export function materialB2CName(log) {
  if (!log) return '';
  const category = [...log.ancestors];
  const name = `${log.name}${log.option ? `: ${log.option}` : ''}`;
  if (log.name) {
    category.push(name);
  }
  return category.join(' > ');
}

export function materialChecklist(checkLists) {
  if (!checkLists) return '';
  return checkLists.map((x, i) => `${i + 1}. ${x.question}: ${x.answer}`).join('\n');
}

export function nameByOriginMaterial(material, type) {
  if (!material) return '';
  const category = material.ancestors.map(x => x.name);
  if (type === 'B2B') {
    if (material.displayName) category.push(material.displayName);
    return category.join(' > ');
  }
  let name = material.name;
  if (material.options) {
    name += `: ${material.options.name}`;
  }
  if (material.name) {
    category.push(name);
  }
  return category.join(' > ');
}

// 앞에 0 가능
export function getOnlyNumber(value) {
  if (!value) return '';
  return value.replace(/[^\.0-9]/g, '');
}

export function isOnlyNumber(value) {
  return /^[0-9]+$/.test(value);
}

export function isRationalNumber(value) {
  return /^[-]?\d*(\.?\d*)$/.test(value);
}

export function isRationalNumberOnlyPlus(value) {
  return /^\d*(\.?\d*)$/.test(value);
}

export function checkEmptyKey(data, exceptions = []) {
  let emptyKey;
  let keys = Object.keys(data);
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i];
    if (!exceptions.includes(key) && typeof data[key] !== 'boolean' && !data[key]) {
      emptyKey = key;
      break;
    }
  }
  return emptyKey;
}

export function cutStr(str, num = 0) {
  if (str.length <= num) return str;
  return `${str.substring(0, num)}...`;
}

export function arrayMove(array, from, to) {
  array = array.slice();
  const startIndex = to < 0 ? array.length + to : to;
  const item = array.splice(from, 1)[0];
  array.splice(startIndex, 0, item);
  return array;
}

export function removeCommonKey(data, keyToRemove) {
  if (!data) return [];
  const newData = data.map(item => {
    const { [keyToRemove]: deletedKey, ...rest } = item;
    return rest;
  });
  return newData;
}

export const onKeyPressSubmit = (e, onSubmit) => {
  if (e.nativeEvent.keyCode === 13 && onSubmit) {
    e.preventDefault();
    onSubmit();
  }
};

export function getImageSet(images) {
  return { srcSet: `${images[1]} 2x, ${images[2]} 3x`, src: images[0] };
}

export const getFileName = url => {
  return decodeURIComponent(decodeURI(url).split('/').slice(-1)[0].split('_').slice(1).join('_'));
};

export const isImage = url => {
  const smallUrl = url.toLowerCase();
  return (
    smallUrl.includes('.jpg') ||
    smallUrl.includes('.jpeg') ||
    smallUrl.includes('.png') ||
    smallUrl.includes('.gif') ||
    smallUrl.includes('.bmp') ||
    smallUrl.includes('.svg') ||
    smallUrl.includes('.webp')
  );
};

export const getFileNameArrayWithExtension = url => {
  const fileName = getFileName(url);
  const lastDotIndex = fileName.lastIndexOf('.');
  return [fileName.slice(0, lastDotIndex), fileName.slice(lastDotIndex + 1)];
};

//숫자 입력 (마이너스, 소수점, 콤마)
export function numberFormat(val, isMinus = false, isFloat = false, isComma = false) {
  if (val !== 0 && !val) return '';
  var str = val.toString();
  //일단 마이너스, 소수점을 제외한 문자열 모두 제거
  str = str.replace(/[^-\.0-9]/g, '');
  //마이너스
  if (isMinus) {
    str = chgMinusFormat(str);
  } else {
    str = str.replace('-', '');
  }

  //소수점
  if (isFloat) {
    str = chgFloatFormat(str);
  } else {
    if (!isMinus) {
      str = str.replace('-', '');
    }
    str = str.replace('.', '');
    if (str.length > 1) {
      str = Math.floor(str);
      str = String(str);
    }
  }

  //콤마처리
  if (isComma) {
    var parts = str.toString().split('.');
    if (str.substring(str.length - 1, str.length) === '.') {
      str = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.';
    } else {
      str = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '');
    }
  }

  return str;
}

function chgFloatFormat(str) {
  var idx = str.indexOf('.');
  if (idx < 0) {
    return str;
  } else if (idx > 0) {
    var tmpStr = str.substr(idx + 1);
    if (tmpStr.length > 1) {
      if (tmpStr.indexOf('.') >= 0) {
        tmpStr = tmpStr.replace(/[^\d]+/g, '');
        str = str.substr(0, idx + 1) + tmpStr;
      }
    }
  } else if (idx === 0) {
    str = '0' + str;
  }
  return str;
}

function chgMinusFormat(str) {
  var idx = str.indexOf('-');
  if (idx === 0) {
    var tmpStr = str.substr(idx + 1);
    //뒤에 마이너스가 또 있는지 확인
    if (tmpStr.indexOf('-') >= 0) {
      tmpStr = tmpStr.replace('-', '');
      str = str.substr(0, idx + 1) + tmpStr;
    }
  } else if (idx > 0) {
    str = str.replace('-', '');
  } else if (idx < 0) {
    return str;
  }
  return str;
}

export function nameWithoutPrefix(name) {
  let newName = name.replace('(주)', '').replace('주식회사', '').replace('(주식회사)', '').trim();
  return newName;
}

export function sortByUpdated(items) {
  return items.sort((a, b) => new Date(b.dateLastUpdated) - new Date(a.dateLastUpdated));
}

export function sortLedgers(items, sort = 'amountDesc') {
  if (sort === 'latest') return sortByUpdated(items);
  return items.sort((a, b) => {
    if (sort === 'amountDesc') {
      return b.sum.profit - a.sum.profit;
    } else {
      return a.sum.profit - b.sum.profit;
    }
  });
}

export function sortCollections(items, sort = 'amountDesc') {
  if (sort === 'latest') return sortByUpdated(items);
  return items.sort((a, b) => {
    const prevCollection = a.sum.collections;
    const prevSales = a.sum.sales;
    const prevAvailable = prevSales - prevCollection;
    const nextCollection = b.sum.collections;
    const nextSales = b.sum.sales;
    const nextAvailable = nextSales - nextCollection;
    if (sort === 'amountDesc') {
      return nextAvailable - prevAvailable;
    } else {
      return prevAvailable - nextAvailable;
    }
  });
}

export function sortGraphData(items, sort = 'amountDesc') {
  if (sort === 'latest') return sortByUpdated(items);
  return items.sort((a, b) => {
    const prevExpense = a.sum.expense;
    const prevSales = a.sum.sales;
    const prevProfit = prevSales - prevExpense;
    const nextExpense = b.sum.expense;
    const nextSales = b.sum.sales;
    const nextProfit = nextSales - nextExpense;
    if (sort === 'amountDesc') {
      return nextProfit - prevProfit;
    } else {
      return nextSales - prevSales;
    }
  });
}

export function getBankData(bank) {
  if (!bank) return {};
  let name = BankCode[bank];
  let value = name && bank;
  if (!name) {
    Object.keys(BankCode).forEach(key => {
      if (BankCode[key] === bank) {
        value = key;
        name = bank;
      }
    });
  }
  return { value, name };
}

export function buildPaymentForm(orders, ahaMoves, logiSpot, selfDelivery, options, discounts) {
  const data = {
    payments: [],
    ahaMoves: [],
    logiSpot: [],
    selfDelivery: [],
    options: [],
    discounts: [],
  };
  const bidders = [];
  orders.forEach(x => {
    const { status, bids, _id, priceInfo, quantity } = x;
    if (status === 'BIDDING') {
      data.payments.push({
        orderId: _id,
        bidId: bids[0]._id,
        amount: parseFloat(priceInfo.priceSaleSum) || parseFloat(priceInfo.priceSale) * parseFloat(quantity),
      });

      bidders.push(bids[0].bidder);
    }
  });
  ahaMoves.forEach(x => {
    if (bidders.includes(x.bidder)) {
      const { _id, estimatedAmount } = x;
      data.ahaMoves.push({ _id, estimatedAmount });
    }
  });
  logiSpot.forEach(x => {
    if (bidders.includes(x.bidder)) {
      const { _id, estimatedAmount } = x;
      data.logiSpot.push({ _id, estimatedAmount });
    }
  });
  selfDelivery.forEach(x => {
    if (bidders.includes(x.bidder)) {
      const { _id, estimatedAmount } = x;
      data.selfDelivery.push({ _id, estimatedAmount });
    }
  });
  options.forEach(x => {
    const { _id, amount } = x;
    data.options.push({ _id, amount });
  });
  discounts.forEach(x => {
    const { _id, amount } = x;
    data.discounts.push({ _id, amount });
  });
  return data;
}

export function isVietnam(user) {
  if (!user) return false;
  return user.phoneCountry === '84';
}
